// @flow

import React, { type Node } from 'react';
import { Portal } from '@tectonics/commons/portal';
import { type Country } from '@tectonics/prs/country';
import { usePendingIncomingPayment, getCountry } from '@tectonics/prs/incoming-payment';
import { Header, TextBlock } from '../../atoms';

export function StatusMessage(): Node {
  const incomingPayment = usePendingIncomingPayment();
  const country = getCountry(incomingPayment);

  return (
    <Portal id="bromelia-status-message">
      <Header size={2}><HeaderText country={country} /></Header>
      <TextBlock flavor="normal"><ContentText country={country} /></TextBlock>
    </Portal>
  );
}

function HeaderText(props: { country: Country  }): Node {
  switch (props.country) {
    case 'br':
      return 'Pedido pendente';
    case 'cl':
    case 'co':
    case 'mx':
      return 'Pedido Pendiente';
    default:
      throw new Error(`Country "${props.country}" not supported`);
  }
}

function ContentText(props: { country: Country }): Node {
  switch (props.country) {
    case 'br':
      return 'Seu pagamento foi recebido. Em breve você receberá um email com mais detalhes.';
    case 'cl':
    case 'co':
    case 'mx':
      return 'Su pago fue recibido. En breve recibirá un email con más detalles.';
    default:
      throw new Error(`Country "${props.country}" not supported`);
  }
}
